import DashboardLayout from 'layouts/dashboard/DashboardLayout';
import OrganizationsTable from 'components/tables/data/organization/OrganizationsTable';
import RequireGlobalPermissionPage from 'components/permissions/RequireGlobalPermissionPage';
import { useMemo } from 'react';

/**
 * Page used to list organizations.
 *
 */
export default function OrganizationsPage() {
  const breadcrumbs = useMemo(() => [{ title: 'Organizácie' }], []);

  return (
    <RequireGlobalPermissionPage permission="manage-organizations">
      <DashboardLayout height="screen" breadcrumbs={breadcrumbs} toggleLabel="Zobraziť vyradené">
        <OrganizationsTable />
      </DashboardLayout>
    </RequireGlobalPermissionPage>
  );
}
